import React from "react";
import Typography from "@mui/material/Typography";
import { Divider } from "@mui/material";
import { useAPI } from "../../../../apiContext";

const CopyRight = () => {
	const { adminData } = useAPI();
	return (
		<div style={{ backgroundColor: "rgb(0 0 0 / 5%)", padding: "15px 0 0 0" }}>
			<Divider className='borderColor' />
			<Typography
				variant='body1'
				component='div'
				className='textColor'
				sx={{ py: 1 }}>
				<a
					className='textColor'
					href={adminData?.footer?.link}
					target='_blank'
					style={{ fontWeight: "bold" }}
					rel='noreferrer'>
					{adminData?.footer?.linkText}
				</a>
				<br />
				{adminData?.footer?.copyRight}
			</Typography>
		</div>
	);
};

export default CopyRight;
